/* Generado por el instalador. No editar a mano. */
export const PHONE_INSTALLED = true;

export { default as SoftphonePage } from '../pages/SoftphonePage';
export { default as SoftphoneCallEndedScreen } from '../components/softphone/SoftphoneCallEndedScreen';
export { tryClosePwaWindow } from '../utils/softphonePwaExit';
export { replaceHistoryForCallEnded } from '../utils/softphonePwaExit';
export function preload_SipSoftphone() { return import('../services/softphone/SipSoftphone'); }
export function preload_softphoneApi() { return import('../services/softphone/softphoneApi'); }
export function preload_kickSoftphoneStart() { return import('../services/softphone/kickSoftphoneStart'); }
export function preload_SoftphoneClient() { return import('../services/softphone/SoftphoneClient'); }
export { fetchSoftphoneHistory } from '../services/softphone/softphoneApi';
export type { SoftphoneHistoryItem } from '../services/softphone/softphoneApi';
export { default as SoftphoneDiscoveryTab } from '../components/softphone/SoftphoneDiscoveryTab';
